// Modal Cefr
export const modalCefr = {
  cefrTitle: 'LIVELLI CEFR',
  cefrContent: [
    {
      title: 'LIVELLO AVANZATO',
      marginTitle: '0.5em',
      topSubTitle: 'C2',
      bottomSubTitle: 'C1',
      topText: 'È in grado di comprendere praticamente tutti i tipi di testo. Sa riassumere informazioni tratte da diverse fonti, orali e scritte, ristrutturando in un testo coerente le argomentazioni e le parti informative. Si esprime spontaneamente, in modo molto scorrevole e preciso e rende distintamente sottili sfumature di significato anche in situazioni piuttosto complesse.',
      bottomText: 'È in grado di comprendere un’ampia gamma di testi complessi e piuttosto lunghi e ne sa ricavare anche il significato implicito.  Si esprime in modo scorrevole e spontaneo, senza un eccessivo sforzo per cercare le parole. Usa la lingua in modo flessibile ed efficace per  scopi sociali, accademici e professionali. Sa produrre testi chiari, ben strutturati e articolati su argomenti complessi, mostrando di saper controllare le strutture discorsive, i connettivi e i meccanismi di coesione.',
      height: '55%',
      heightTop: '45%',
      bottom: true,
    },
    {
      title: 'LIVELLO INTERMEDIO',
      marginTitle: '0.5em',
      topSubTitle: 'B2',
      bottomSubTitle: 'B1',
      topText: "È in grado di comprendere le idee fondamentali di testi complessi su argomenti sia concreti sia astratti, comprese le discussioni tecniche nel proprio settore di specializzazione. È in grado di interagire con relativa scioltezza e spontaneità, tanto che l'interazione con un parlante nativo si sviluppa senza eccessiva fatica e tensione. Sa produrre testi chiari e articolati su un’ampia gamma di argomenti e esprimere un’opinione su un argomento d’attualità, esponendo i pro e i contro delle diverse opzioni.",
      bottomText: 'È in grado di comprendere i punti essenziali di messaggi chiari in lingua standard su argomenti familiari che affronta normalmente al lavoro, a scuola, nel tempo libero, ecc. Se la cava in molte situazioni che si possono presentare viaggiando in una regione dove si parla la lingua in questione. Sa produrre testi semplici e coerenti su argomenti che gli siano familiari o siano di suo interesse. È in grado di descrivere esperienze e avvenimenti, sogni, speranze, ambizioni, di esporre brevemente ragioni e dare spiegazioni su opinioni e progetti.',
      height: '50%',
      bottom: true,
    },
    {
      title: 'LIVELLO ELEMENTARE',
      marginTitle: '0.5em 0 0.5em 0',
      topSubTitle: 'A2',
      bottomSubTitle: 'A1',
      topText: 'È in grado di comprendere frasi isolate ed espressioni di uso frequente relative ad ambiti di immediata rilevanza (ad es. informazioni di base sulla persona e sulla famiglia, acquisti, geografia locale, lavoro). Riesce a comunicare in attività semplici e di routine che richiedono solo uno scambio di informazioni semplice e diretto su argomenti familiari e abituali. Riesce a  descrivere in termini semplici aspetti del proprio vissuto e del proprio ambiente ed elementi che si riferiscono a bisogni immediati.',
      bottomText: 'È in grado di comprendere e utilizzare espressioni familiari di uso quotidiano e formule molto comuni per soddisfare bisogni di tipo concreto. Sa presentare se stesso/a e altri ed è in grado di porre domande su dati personali e rispondere a domande analoghe (il luogo dove abita, le persone che conosce, le cose che possiede). È in grado di interagire in modo semplice purché l’interlocutore parli lentamente e chiaramente e sia disposto a collaborare.',
      height: '50%',
      bottom: false,
    },
  ],
};

// Modal attestazione
export const modalAttestazione = {
  attestazioneTitle: 'ATTESTAZIONE DI CONOSCENZA DELLA LINGUA ITALIANA',
  attestazioneSubTitle: "CHE COS'è l'attestazione?",
  attestazioneTextTop: [
    {
      text: 'Le Scuole possono rilasciare tre tipi di attestazione: di partecipazione, di frequenza oppure di livello.',
      bold: false,
      block: true,
    },
    {
      text: 'Solo quelle rilasciate dai Centri Provinciali per l’Istruzione degli Adulti (CPIA) hanno valore per il rilascio o per il rinnovo di alcuni titoli di soggiorno rilasciati dalle Autorità italiane, in particolare:',
      bold: false,
      block: true,
    },
    {
      text: "L'Attestazione di livello A2",
      bold: true,
      block: false,
    },
    {
      text: 'è valida per il rilascio del permesso di soggiorno di lungo periodo e per il rispetto di quanto sottoscritto nell’Accordo di Integrazione;',
      bold: false,
      block: true,
    },
    {
      text: "L'attestazione di livello B1",
      bold: true,
      block: false,
    },
    {
      text: 'è utile per la richiesta di cittadinanza.',
      bold: false,
      block: true,
    },
  ],
  attestazioneTextCenter: "Questo in virtù dell'Accordo Quadro sottoscritto nel 2010 tra il Ministero dell'Interno e il Ministero dell'Istruzione, dell'Università e della Ricerca.",
  attestazioneTextBottom: [
    {
      text: 'Dall’anno scolastico 2014/2015 inoltre i Centri Provinciali per l’Istruzione degli Adulti (CPIA), istituiti nel 2012, sostituiscono del tutto i Centri Territoriali Permanenti (CTP) diventando quindi i protagonisti nell’ambito dell’alfabetizzazione della lingua italiana degli adulti (dai 16 anni).',
    },
    {
      text: 'Al termine dei corsi e dopo il superamento di un test finale, il CPIA (ex CTP) rilascia un Attestato di lingua italiana di livello.',
    },
  ],
};

// modal certificazione
export const modalCertificazione = {
  certificazioneTitle: 'CERTIFICAZIONE DI LINGUA ITALIANA',
  certificazioneCheCosaE: {
    title: 'Che cos’è la certificazione di italiano?',
    textTop: 'La certificazione di italiano è un documento che “certifica” il livello di conoscenza della lingua italiana ed è ufficialmente riconosciuto a livello internazionale.',
    textBottom: 'La certificazione è diversa dall’ “Attestazione” che viene rilasciata dai CPIA per il Permesso di soggiorno a punti o per il Permesso CEE per soggiornanti di lungo periodo (ex carta di soggiorno).',
  },
  certificazioneCheCosaServe: {
    title: 'A che cosa serve la certificazione di italiano?',
    text: 'Avere un documento ufficiale che indica il livello di conoscenza dell’Italiano aiuta nello studio e nel lavoro, può servire per proseguire la formazione iniziata nel proprio Paese e per trovare un lavoro migliore.',
  },
  certificazioneComeSiOttiene: {
    title: 'Come si ottiene la certificazione?',
    text: "Per ottenere la certificazione bisogna superare un esame del livello di italiano che pensi di avere raggiunto. L'esame di lingua è composto da quattro prove: ascolto, lettura, scrittura e parlato.  È possibile prendere parte all’esame dopo aver seguito un corso, ma non è obbligatorio: ci sono centri certificatori in cui ci si può iscrivere direttamente al test. Se non superi solo una delle quattro prove potrai ripeterla, mantenendo valide le altre prove superate.",
  },
  certificazioneChiRilascia: {
    title: 'Chi rilascia la certificazione di italiano?',
    text: "La certificazione di italiano come lingua straniera (livelli A1,A2,B1,B2,C1,C2) può essere rilasciata dai quattro enti certificatori riconosciuti dal Ministero degli Internie dell'Istruzione e riuniti dal 2013 nell'Associazione CLIQ (Certificazione Lingua Italiana di Qualità): ",
    list: [
      "L'Università per Stranieri di Siena rilascia la Certificazione di Italiano come Lingua Straniera (CILS)",
      'L’Università per Stranieri di Perugia rilascia la Certificazione Europea Lingua Italiana (CELI)',
      'L’Università degli Studi Roma Tre rilascia la Certificazione di lingua Italiana L2 (CERT.IT)',
      'La Società Dante Alighieri rilascia la certificazione Progetto Lingua Italiana Dante Alighieri (PLIDA)',
    ],
  },
  certificazioneQuantoCosta: {
    title: 'Quanto costa fare la certificazione?',
    text1: 'Di seguito riportiamo i costi generali della certificazione.',
    text2: 'Spesso i centri di esame attuano prezzi ridotti per gli studenti che hanno frequentato i loro corsi.',
    table: {
      heading: [
        {
          text: 'CILS',
          link: 'https://cils.unistrasi.it',
        },
        {
          text: 'CELI IMMIGRATI',
          link: 'https://www.unistrapg.it/it/certificati-di-conoscenza-della-lingua-italiana/certificati-di-conoscenza-della-lingua-italiana-iscrizioni',
        },
        {
          text: 'CELI STANDARD',
          link: 'https://www.unistrapg.it/it/certificati-di-conoscenza-della-lingua-italiana/certificati-di-conoscenza-della-lingua-italiana-iscrizioni',
        },
        {
          text: 'PLIDA',
          link: 'https://plida.it/certificazione-plida/faq.html',
        },
        {
          text: 'CER.IT',
          link: 'http://www.certificazioneitaliano.uniroma3.it/A1-IT.aspx',
        },
      ],
      columnSx: [
        {
          text: 'A1',
          background: false,
          right: false,
          bottomGrey: false,
          color: 'white',
        },
        {
          text: 'A1',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
        {
          text: 'A2',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
        {
          text: 'B1',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
        {
          text: 'B2',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
        {
          text: 'C1',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
        {
          text: 'C2',
          background: true,
          right: true,
          bottomGrey: true,
          color: 'blue',
        },
      ],
      content: {
        contentLIVELLI: ['€ 40,00', '€ 15,38', '€ 100,00', '€ 65,00', '€ 35,00'],
        contentCILS: ['€ 40,00', '€ 35,00', '€ 100,00', '€ 65,00', '€ 40,00'],
        contentCELIIMMIGRATI: ['€ 90,00*', '€ 50,00', '€ 100,00', '€ 95,00', '€ 80,00'],
        contentCELISTANDARD: ['€ 105,00', '-', '€ 100,00', '€ 95,00', '€ 140,00'],
        contentPLIDA: ['€ 135,00', '-', '€ 100,00', '€ 135,00', '€ 200,00'],
        contentCER: ['€ 160,00', '-', '€ 100,00', '€ 135,00', '€ 200,00'],
      },
    },
    text3: "* per la certificazione CILS, livello B1, esiste un esame specifico per adolescenti al prezzo di €70,00 ed un esame dedicato all'otteni mento della  cittadinanza italiana al prezzo di €100,00",
  },
  certificazioneAfterQuantoCosta: 'I dati sono aggiornati a febbraio 2021. Visitare il sito degli ENTI CERTIFICATORI per informazioni più aggiornate.',
  certificazioneDoveOttenere: {
    title: 'Dove si può ottenere la certificazione a Milano?',
    text: "Si può effettuare l'esame di certificazione presso i CENTRI CERTIFICATORI che sono convenzionati con gli ENTI CERTIFICATORI. Molte sono le scuole a Milano in cui è possibile sostenere l'esame. Per sapere quali sono e quale certificazione rilasciano si può contattare il nostro servizio o consultare i seguenti siti:",
    list: [
      {
        text: 'Certificazione CELI',
        link: 'http://www.cvcl.it/ricercasedi/homericerca.aspx?qst=celi',
      },
      {
        text: 'Certificazione PLIDA',
        link: 'https://plida.it/',
      },
      {
        text: 'Certificazione CILS',
        link: 'https://cils.unistrasi.it/1/179/56/Lombardia.htm',
      },
      {
        text: 'Certificazione CERT.IT L2',
        link: 'http://www.certificazioneitaliano.uniroma3.it/CentriEsame.aspx',
      },
    ],
  },
};

export const certificazioneTableMobile = [
  {
    heading: {
      text: 'CILS',
      link: 'https://cils.unistrasi.it/88/176/Iscrizione_nella_sede_Siena.htm',
    },
    content: ['€ 40,00', '€ 40,00', '€ 90,00*', '€ 105,00', '€ 135,00', '€ 160,00'],
  },
  {
    heading: {
      text: 'CELI IMMIGRATI',
      link: 'https://www.unistrapg.it/it/certificati-di-conoscenza-della-lingua-italiana/certificati-di-conoscenza-della-lingua-italiana-iscrizioni',
    },
    content: ['€ 15,38', '€ 35,00', '€ 50,00', '-', '-', '-'],
  },
  {
    heading: {
      text: 'CELI STANDARD',
      link: 'https://www.unistrapg.it/it/certificati-di-conoscenza-della-lingua-italiana/certificati-di-conoscenza-della-lingua-italiana-iscrizioni',
    },
    content: ['€ 100,00', '€ 100,00', '€ 100,00', '€ 100,00', '€ 100,00', '€ 100,00'],
  },
  {
    heading: {
      text: 'PLIDA',
      link: 'https://plida.it/certificazione-plida/faq.html',
    },
    content: ['€ 70,00', '€ 70,00', '€ 100,00', '€ 100,00', '€ 145,00', '€ 145,00'],
  },
  {
    heading: {
      text: 'CER.IT',
      link: 'http://www.certificazioneitaliano.uniroma3.it/A1-IT.aspx',
    },
    content: ['€ 35,00', '€ 40,00', '€ 80,00', '€ 140,00', '€ 200,00', '€ 200,00'],
  },
];
